import React, { Component } from "react";
import * as actions from "../../../redux/actions";

// Redux
import { connect } from "react-redux";

// Styles
import CustomPageStyle from "./style";

import dtrcActive from "../../../assets/icon/dtrc-active.png";
import dtrcInactive from "../../../assets/icon/dtrc-inactive.png";
import drvmActive from "../../../assets/icon/drvm-active.png";
import drvmInactive from "../../../assets/icon/drvm-inactive.png";


class SwitchService extends Component {
  constructor(props) {
    super(props);

  }
 

  _switchServiceType = (service) => {
    
    this.props.onChangeServiceType(service);
  }


  render() {
    const { projectService } = this.props;
    
    return (
      <CustomPageStyle>
        {/* Bottom navigation */}
        <div className="buttonBottom d-flex justify-content-between">
          <div
            className={`d-flex justify-center width50`}
            onClick={() => this._switchServiceType("dtrc")}
          >
            <div className="isoImgWrapper">
              <img alt="" crossOrigin="anonymous" src={projectService === "dtrc" ? dtrcActive : dtrcInactive} />
            </div>
          </div>
          <div
            className={`d-flex justify-center width50`}
            onClick={() => this._switchServiceType("drvm")}
          >
            <div className="isoImgWrapper">
              <img alt="" crossOrigin="anonymous" src={projectService === "drvm" ? drvmActive : drvmInactive} />
            </div>
          </div>
        </div>

      </CustomPageStyle>
    );
  }
}

const mapStateToProps = state => {
  const { projectService } = state.Auth;

  return { projectService };

};

const mapDispatchToProps = dispatch => {
  return {
    
    onChangeServiceType: params => dispatch(actions.changeServiceType(params))
  };
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SwitchService);
